import * as React from 'react';
import classNames from 'classnames';
import './Notification.scss';

type NotificationProps = {
    message: String;
    onClose?: () => void;
    timeout: number;
}

const ToastStates = {
  SHOW: 1,
  TRANSITION: 2,
  HIDE: 3,
};

class Notification extends React.Component<NotificationProps> {
  // eslint-disable-next-line react/sort-comp
  hideTimeout;
  transitionTimeOut;
  constructor(props) {
    super(props);
    this.state = {
      toastState: ToastStates.SHOW,
    };
    this.closeToast = this.closeToast.bind(this);
  }

  componentDidMount() {
    const { timeout } = this.props;
    this.transitionTimeOut = setTimeout(() => {
      this.setState({ toastState: ToastStates.TRANSITION });
    }, timeout - 500);

    this.hideTimeout = setTimeout(() => {
      this.props.onClose();
    }, timeout);
  }

  closeToast(e) {
    e.preventDefault();
    clearTimeout(this.transitionTimeOut);
    this.setState({ toastState: ToastStates.TRANSITION });
    setTimeout(() => {
      this.setState({ toastState: ToastStates.HIDE });
    }, 500);
  }

  render() {
    const { message } = this.props;
    const { toastState } = this.state;
    return (
      <div id="snackbar" className={classNames('', { showToast: toastState === ToastStates.SHOW, transitionToast: toastState === ToastStates.TRANSITION, hideToast: toastState === ToastStates.HIDE })}>
        <div className="toast-success"><i className="icon icon-check" /></div>
        <div className="toast-message">{message}</div>
        <i id="close-notification" className="icon icon-close" role="button" tabIndex={0} onClick={this.closeToast} onKeyDown={this.closeToast} />
      </div>);
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/BusinessList/components/Notification.js